module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.backgroundDialog),
      callback: function($$v) {
        _vm.backgroundDialog = $$v
      },
      expression: "backgroundDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n          Choose a background picture\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "input": _vm.saveBackground
    },
    model: {
      value: (_vm.profile.background_picture),
      callback: function($$v) {
        _vm.$set(_vm.profile, "background_picture", $$v)
      },
      expression: "profile.background_picture"
    }
  })], 1)], 1), _vm._v(" "), _c('v-img', {
    attrs: {
      "height": "250",
      "src": _vm.backgroundPicture
    }
  }, [_c('v-card-title', {
    staticClass: "title pl-4 white--text",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.me.first_name) + " " + _vm._s(_vm.me.last_name) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [_vm._v("\n          Change profile picture\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = true
      }
    }
  }, [_vm._v("\n          Change background picture\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.profile.profile_picture) ? _c('v-avatar', {
    staticClass: "elevation-10",
    staticStyle: {
      "margin-top": "-120px",
      "margin-left": "50px"
    },
    attrs: {
      "absolute": "",
      "size": 180
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [(_vm.getMeReq.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "size": 100
    }
  }) : _c('v-img', {
    attrs: {
      "src": _vm.profile.profile_picture,
      "height": "180",
      "width": "180"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.logoDialog),
      callback: function($$v) {
        _vm.logoDialog = $$v
      },
      expression: "logoDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Update your Profile picture\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
    attrs: {
      "path": _vm.profilePath,
      "filename": "profile_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.getMe();
        _vm.logoDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3",
    attrs: {
      "tile": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.me
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Contact details\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.contactsForm), function(field) {
    return _c('v-flex', {
      key: field.label,
      class: field.flexClass
    }, [(field.type === "divider") ? _c('v-divider') : _c('v-text-field', {
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.me, field.model)
      },
      model: {
        value: (_vm.me[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.me, field.model, $$v)
        },
        expression: "me[field.model]"
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.me.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveMe
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.profile
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Extra information\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('profession-picker', {
    model: {
      value: (_vm.profile.profession),
      callback: function($$v) {
        _vm.$set(_vm.profile, "profession", $$v)
      },
      expression: "profile.profession"
    }
  }), _vm._v(" "), _vm._l((_vm.extrasForm), function(field) {
    return [(field.type === "divider") ? _c('v-divider', {
      key: field.label
    }) : (field.type === "checkbox") ? _c('v-checkbox', {
      attrs: {
        "label": field.label,
        "error-messages": _vm.getErrors(_vm.requests.me, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    }) : (field.component) ? _c(field.component, {
      tag: "component",
      attrs: {
        "attrs": field.attrs
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    }) : _c('v-text-field', {
      key: field.label,
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.profile, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.profile.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveExtras
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.profile
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Social's\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._l((_vm.socialsForm), function(field) {
    return [(field.type === "divider") ? _c('v-divider', {
      key: field.label
    }) : _c('v-text-field', {
      key: field.label,
      attrs: {
        "hint": field.hint,
        "label": field.label,
        "multi-line": field.multiLine,
        "error-messages": _vm.getErrors(_vm.requests.profile, field.model)
      },
      model: {
        value: (_vm.profile[field.model]),
        callback: function($$v) {
          _vm.$set(_vm.profile, field.model, $$v)
        },
        expression: "profile[field.model]"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.getMeReq.loading
    },
    on: {
      "click": _vm.getMe
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.profile.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveSocials
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "overline"
  }, [_vm._v("Change your password")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Enter a new password",
      "hint": "At least 8 characters",
      "min": "8",
      "loading": _vm.changePasswordReq.loading,
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "type": _vm.passwordVisible ? 'password' : 'text',
      "counter": ""
    },
    on: {
      "click:append": function($event) {
        _vm.passwordVisible = !_vm.passwordVisible
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "req-id": _vm.changePassReqId,
      "text": "Save"
    },
    on: {
      "save": _vm.changePassword
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64704ae7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/Profile.vue
// module id = 1448
// module chunks = 9